import { useNavigate } from "react-router-dom";

/**
 * Master v5 Prompt 16 — honest placeholder for the cross-Workspace
 * Sessions/Feedback/Messages/Files/Library workbenches (Prompts 18-20
 * scope). The per-client version of each of these already exists and
 * works today (Prompts 9-13) — this points the coach there via
 * Clients rather than pretending a cross-Workspace view exists yet.
 */
export default function CoachComingSoon({ title }) {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg" data-testid="coach-coming-soon-page">
      <h1 className="font-serif text-2xl text-ink mb-2">{title}</h1>
      <p className="text-sm text-ink-soft mb-6">
        A cross-client {title.toLowerCase()} workbench is coming in a later prompt. For now, open a client from
        Clients to see their {title.toLowerCase()}.
      </p>
      <button
        onClick={() => navigate("/rehearsal-room/coach/clients")}
        className="text-sm text-terracotta hover:underline"
        data-testid="coach-coming-soon-go-to-clients"
      >
        Go to Clients →
      </button>
    </div>
  );
}
